/**
* 飞机杯 远程控制
*/
<template>
	<div>
		<link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">
		<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css">

		<!-- 数据加载提示框 -->
		<van-overlay :show="isDataLoading" @click="show = false">
			<div style="display: flex;align-items: center;justify-content: center; height: 100%;" @click.stop>
				<van-loading size="24px" vertical>{{ $t('language000053') }}</van-loading>
			</div>
		</van-overlay>

		<div class="min-h-screen bg-gray-50 pb-20">
			<div class="fixed top-0 w-full bg-white shadow-md z-50 px-4 py-3">
				<button @click="queryPruchasedPackages"
					:class="[ '!rounded-button w-full py-3 flex items-center justify-center gap-2',isConnected ? 'bg-green-500 text-white' : 'bg-red-500 text-white']">
					<i :class="['fas', isConnected ? 'fa-link' : 'fa-unlink']"></i>
					{{ isConnected ? $t('language000421') : $t('language000422') }}
				</button>
			</div>

			<div class=" pt-20 px-4 min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 text-gray-800 font-sans"
				:class="{ 'opacity-50 pointer-events-none': !isConnected }">

				<!-- 主要的操作界面 -->
				<main class="max-w-6xl mx-auto px-8 py-10 space-y-10">

					<section class="bg-white rounded-2xl shadow-md p-6">
						<h2 class="text-xl font-semibold mb-4 flex items-center">
							<i class="fas fa-sliders-h mr-2 text-purple-500"></i>
							<!-- 经典模式 -->
							{{ $t('language000431') }}
						</h2>
						<div class="space-y-6">
							<div class="flex items-center justify-between">
								<span>
									<!-- 经典模式开关 -->
									{{ $t('language000432') }}
								</span>
								<button @click="toggleClassicMode"
									:class="classicMode.enabled ? 'bg-green-500' : 'bg-gray-300'"
									class="relative inline-flex h-6 w-11 items-center rounded-full transition-colors">
									<span :class="classicMode.enabled ? 'translate-x-6' : 'translate-x-1'"
										class="inline-block h-4 w-4 transform rounded-full bg-white transition-transform" />
								</button>
							</div>

							<div v-if="classicMode.enabled" class="space-y-6 pl-4 border-l-2 border-gray-200">
								<div>
									<label class="block mb-2">
										<!-- 旋转模式 -->
										{{ $t('language000433') }}
									</label>
									<div class="grid grid-cols-5 gap-2">
										<button v-for="mode in 10" :key="mode" @click="classicMode.rotationMode = mode"
											:class="{
						                                'bg-purple-500 text-white': classicMode.rotationMode === mode,
						                                'bg-gray-100 hover:bg-gray-200': classicMode.rotationMode !== mode
						                            }" class="!rounded-button whitespace-nowrap py-2 px-3 text-sm transition-colors">
											{{ mode === 0 ? $t('language000434') : $t('language000435', { mode: mode }) }}
										</button>
									</div>
								</div>

								<div>
									<label class="block mb-2">
										<!-- 旋转强度 -->
										{{ $t('language000436') }}
										: {{ classicMode.rotationIntensity }}</label>
									<input v-model="classicMode.rotationIntensity" type="range" min="0" max="100"
										class="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer">
								</div>

								<div>
									<label class="block mb-2">
										<!-- 电击模式 -->
										{{ $t('language000437') }}
									</label>
									<div class="grid grid-cols-5 gap-2">
										<button v-for="mode in 10" :key="mode" @click="classicMode.shockMode = mode"
											:class="{
						                                'bg-purple-500 text-white': classicMode.shockMode === mode,
						                                'bg-gray-100 hover:bg-gray-200': classicMode.shockMode !== mode
						                            }" class="!rounded-button whitespace-nowrap py-2 px-3 text-sm transition-colors">
											{{ mode === 0 ? $t('language000434') : $t('language000435', { mode: mode }) }}
										</button>
									</div>
								</div>

								<div>
									<label class="block mb-2">
										<!-- 电击强度 -->
										{{ $t('language000438') }}
										: {{ classicMode.shockIntensity }}</label>
									<input v-model="classicMode.shockIntensity" type="range" min="0" max="100"
										class="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer">
								</div>

								<div>
									<label class="block mb-2">
										<!-- 旋转方向 -->
										{{ $t('language000439') }}
									</label>
									<div class="flex space-x-4">
										<button @click="classicMode.rotationDirection = 1" :class="{
						                                'bg-purple-500 text-white': classicMode.rotationDirection === 1,
						                                'bg-gray-100 hover:bg-gray-200': classicMode.rotationDirection !== 1
						                            }" class="!rounded-button whitespace-nowrap flex-1 py-2 px-4 transition-colors">
											<i class="fas fa-redo mr-2"></i>
											<!-- 顺时针 -->
											{{ $t('language000440') }}
										</button>
										<button @click="classicMode.rotationDirection = 2" :class="{
						                                'bg-purple-500 text-white': classicMode.rotationDirection === 2,
						                                'bg-gray-100 hover:bg-gray-200': classicMode.rotationDirection !== 2
						                            }" class="!rounded-button whitespace-nowrap flex-1 py-2 px-4 transition-colors">
											<i class="fas fa-undo mr-2"></i>
											<!-- 逆时针 -->
											{{ $t('language000441') }}
										</button>
									</div>
								</div>

								<button @click="sendClassicModeCommand"
									class="!rounded-button whitespace-nowrap w-full bg-purple-500 hover:bg-purple-600 text-white py-3 transition-colors">
									<!-- 应用经典模式设置 -->
									{{ $t('language000442') }}
								</button>
							</div>
						</div>
					</section>

					<section class="bg-white rounded-2xl shadow-md p-6">
						<h2 class="text-xl font-semibold mb-4 flex items-center">
							<i class="fas fa-bolt mr-2 text-red-500"></i>
							<!-- 狂暴模式 -->
							{{ $t('language000443') }}
						</h2>
						<div class="flex items-center justify-between">
							<span>
								<!-- 狂暴模式开关 -->
								{{ $t('language000444') }}
							</span>
							<button @click="toggleRageMode" :class="rageMode.enabled ? 'bg-red-500' : 'bg-gray-300'"
								class="relative inline-flex h-6 w-11 items-center rounded-full transition-colors">
								<span :class="rageMode.enabled ? 'translate-x-6' : 'translate-x-1'"
									class="inline-block h-4 w-4 transform rounded-full bg-white transition-transform" />
							</button>
						</div>
						<div v-if="rageMode.enabled" class="mt-6">
							<button @click="sendRageModeCommand"
								class="!rounded-button whitespace-nowrap w-full bg-red-500 hover:bg-red-600 text-white py-3 transition-colors">
								<!-- 激活狂暴模式 -->
								{{ $t('language000445') }}
							</button>
						</div>
					</section>

					<section class="bg-white rounded-2xl shadow-md p-6">
						<h2 class="text-xl font-semibold mb-4 flex items-center">
							<i class="fas fa-random mr-2 text-yellow-500"></i>
							<!-- 随机模式 -->
							{{ $t('language000446') }}
						</h2>
						<div class="space-y-6">
							<div class="flex items-center justify-between">
								<span>
									<!-- 随机模式开关 -->
									{{ $t('language000447') }}
								</span>
								<button @click="toggleRandomMode"
									:class="randomMode.enabled ? 'bg-yellow-500' : 'bg-gray-300'"
									class="relative inline-flex h-6 w-11 items-center rounded-full transition-colors">
									<span :class="randomMode.enabled ? 'translate-x-6' : 'translate-x-1'"
										class="inline-block h-4 w-4 transform rounded-full bg-white transition-transform" />
								</button>
							</div>

							<div v-if="randomMode.enabled" class="space-y-6 pl-4 border-l-2 border-gray-200">
								<div>
									<label class="block mb-2">
										<!-- 最小强度 -->
										{{ $t('language000448') }}
										: {{ randomMode.minIntensity }}</label>
									<input v-model="randomMode.minIntensity" type="range" min="0"
										:max="randomMode.maxIntensity"
										class="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer">
								</div>
								<div>
									<label class="block mb-2">
										<!-- 最大强度 -->
										{{ $t('language000449') }}
										: {{ randomMode.maxIntensity }}</label>
									<input v-model="randomMode.maxIntensity" type="range" :min="randomMode.minIntensity"
										max="100"
										class="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer">
								</div>

								<button @click="sendRandomModeCommand"
									class="!rounded-button whitespace-nowrap w-full bg-yellow-500 hover:bg-yellow-600 text-white py-3 transition-colors">
									<!-- 应用随机模式设置 -->
									{{ $t('language000450') }}
								</button>
							</div>
						</div>
					</section>

					<section class="bg-white rounded-2xl shadow-md p-6">
						<h2 class="text-xl font-semibold mb-4 flex items-center">
							<i class="fas fa-mobile-alt mr-2 text-green-500"></i>
							<!-- 摇一摇/语音控制 -->
							{{ $t('language000451') }}
						</h2>
						<div class="space-y-6">
							<div class="flex items-center justify-between">
								<span>
									<!-- 摇一摇功能开关 -->
									{{ $t('language000452') }}
								</span>
								<button @click="toggleShakeMode"
									:class="shakeMode.enabled ? 'bg-green-500' : 'bg-gray-300'"
									class="relative inline-flex h-6 w-11 items-center rounded-full transition-colors">
									<span :class="shakeMode.enabled ? 'translate-x-6' : 'translate-x-1'"
										class="inline-block h-4 w-4 transform rounded-full bg-white transition-transform" />
								</button>
							</div>

							<div v-if="shakeMode.enabled" class="space-y-6 pl-4 border-l-2 border-gray-200">
								<div>
									<label class="block mb-2">
										<!-- 旋转强度 -->
										{{ $t('language000436') }}
										: {{ shakeMode.rotationIntensity }}</label>
									<input v-model="shakeMode.rotationIntensity" type="range" min="0" max="100"
										class="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer">
								</div>

								<div>
									<label class="block mb-2">
										<!-- 电击强度 -->
										{{ $t('language000438') }}
										: {{ shakeMode.shockIntensity }}</label>
									<input v-model="shakeMode.shockIntensity" type="range" min="0" max="100"
										class="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer">
								</div>

								<div>
									<label class="block mb-2">
										<!-- 旋转方向 -->
										{{ $t('language000439') }}
									</label>
									<div class="flex space-x-4">
										<button @click="shakeMode.rotationDirection = 1" :class="{
						                                'bg-green-500 text-white': shakeMode.rotationDirection === 1,
						                                'bg-gray-100 hover:bg-gray-200': shakeMode.rotationDirection !== 1
						                            }" class="!rounded-button whitespace-nowrap flex-1 py-2 px-4 transition-colors">
											<i class="fas fa-redo mr-2"></i>
											<!-- 顺时针 -->
											{{ $t('language000440') }}
										</button>
										<button @click="shakeMode.rotationDirection = 2" :class="{
						                                'bg-green-500 text-white': shakeMode.rotationDirection === 2,
						                                'bg-gray-100 hover:bg-gray-200': shakeMode.rotationDirection !== 2
						                            }" class="!rounded-button whitespace-nowrap flex-1 py-2 px-4 transition-colors">
											<i class="fas fa-undo mr-2"></i>
											<!-- 逆时针 -->
											{{ $t('language000441') }}
										</button>
									</div>
								</div>

								<button @click="sendShakeModeCommand"
									class="!rounded-button whitespace-nowrap w-full bg-green-500 hover:bg-green-600 text-white py-3 transition-colors">
									<!-- 应用摇一摇设置 -->
									{{ $t('language000453') }}
								</button>
							</div>
						</div>
					</section>
				</main>
			</div>

		</div>
	</div>
</template>

<script>
	import Cookies from 'js-cookie';
	import axios from 'axios';

	export default {
		data() {
			return {
				isDataLoading: false, //加载数据提示框
				toyId: "", //传递过来的值 设备ID
				receiverID: "", //传递过来的值 生成链接的ID
				uuid: "", //传递过来的值 uuid 唯一标识
				isConnected: false, //设备是否成功连接

				// 电量状态 (对应 ref)
				batteryLevel: 85,

				// 经典模式状态 (对应 reactive)
				classicMode: {
					enabled: false,
					rotationMode: 0,
					rotationIntensity: 50,
					shockMode: 0,
					shockIntensity: 50,
					rotationDirection: 1 // 1: 顺时针, 2: 逆时针
				},

				// 狂暴模式状态 (对应 reactive)
				rageMode: {
					enabled: false
				},

				// 随机模式状态 (对应 reactive)
				randomMode: {
					enabled: false,
					minIntensity: 20,
					maxIntensity: 80
				},

				// 摇一摇模式状态 (对应 reactive)
				shakeMode: {
					enabled: false,
					rotationIntensity: 50,
					shockIntensity: 50,
					rotationDirection: 1
				}
			};
		},
		mounted() {
			this.toyId = this.$route.params.toyId; //设备ID
			this.receiverID = this.$route.params.receiverID; //生成链接的ID
			this.uuid = this.$route.params.uuid; //uuid 唯一标识

			const userLanguage = navigator.language || navigator.userLanguage;
			const isLanguageSupported = this.$p_languages.includes(userLanguage);
			this.$i18n.locale = isLanguageSupported ? userLanguage : this.$p_defaultLanguage;
		},
		methods: {
			queryPruchasedPackages() { //H5查询App是否已连接设备
				this.isDataLoading = true;
				axios.post(this.$p_url + '/feign/airplane_cup/h5/getAppConnectToyStatus/' + this.toyId, {}, {
						withCredentials: true,
						headers: {
							'Content-Type': 'application/json',
							'Accept': '*/*',
							'token': Cookies.get("token"),
						},
					})
					.then(response => {
						this.isDataLoading = false;
						console.log("H5查询App是否已连接设备：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							if (response.data.data.appConnectStatus == 0) { //app端连接设备的状态 默认0未连接，1已连接
								this.open4(this.$t('language000429')); //APP未连接设备
								this.isConnected = false;
							}
							if (response.data.data.appConnectStatus == 1) { //app端连接设备的状态 默认0未连接，1已连接
								this.isConnected = true;
								this.pushMsgToApp("mqtt_h5_100001") //推送
							}
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.isDataLoading = false;
						console.error('Error fetching data:', error);
					});
			},
			//----------------------------------------------------------------------------------------------------------------------------------------------
			//经典模式
			toggleClassicMode() { //开启或者关闭 经典模式
				this.queryPruchasedPackages() //查询是否连接
				this.classicMode.enabled = !this.classicMode.enabled;
				if (!this.classicMode.enabled) {
					const str = [
						"AA",
						"01",
						"00", //关闭
						this.classicMode.rotationIntensity,
						this.classicMode.shockMode,
						this.classicMode.shockIntensity,
						this.classicMode.rotationDirection
					];
					this.command = str.map(byte => byte.toString(16).toUpperCase().padStart(2, '0')).join('');
					this.pushMsgToApp("mqtt_h5_100002") //推送
					console.log('关闭经典模式指令:', this.command);
				}
			},

			sendClassicModeCommand() { // 发送经典模式指令
				const str = [
					"AA",
					"01",
					this.classicMode.rotationMode,
					this.classicMode.rotationIntensity,
					this.classicMode.shockMode,
					this.classicMode.shockIntensity,
					this.classicMode.rotationDirection
				];
				this.command = str.map(byte => byte.toString(16).toUpperCase().padStart(2, '0')).join('');
				this.pushMsgToApp("mqtt_h5_100002") //推送
				console.log('发送经典模式指令:', this.command);
			},

			//----------------------------------------------------------------------------------------------------------------------------------------------
			//狂暴模式
			toggleRageMode() { //开启或者关闭 切换狂暴模式
				this.rageMode.enabled = !this.rageMode.enabled;
				if (!this.rageMode.enabled) {
					const str = ["AA", "02", "00"];
					this.command = str.map(byte => byte.toString(16).toUpperCase().padStart(2, '0')).join('');
					this.pushMsgToApp("mqtt_h5_100002") //推送
					console.log('关闭狂暴模式指令:', this.command);
				}
			},

			sendRageModeCommand() { // 发送狂暴模式指令
				const str = ["AA", "02", "01"];
				this.command = str.map(byte => byte.toString(16).toUpperCase().padStart(2, '0')).join('');
				this.pushMsgToApp("mqtt_h5_100002") //推送
				console.log('发送狂暴模式指令:', this.command);
			},

			//----------------------------------------------------------------------------------------------------------------------------------------------
			//随机模式
			toggleRandomMode() { //开启或者关闭 切换随机模式
				this.randomMode.enabled = !this.randomMode.enabled;
				if (!this.randomMode.enabled) {
					const str = ["AA", "03", "00", this.randomMode.minIntensity, this.randomMode.maxIntensity];
					this.command = str.map(byte => byte.toString(16).toUpperCase().padStart(2, '0')).join('');
					this.pushMsgToApp("mqtt_h5_100002") //推送
					console.log('关闭切换随机模式指令:', this.command);
				}
			},

			sendRandomModeCommand() { // 发送随机模式指令
				const str = ["AA", "03", "01", this.randomMode.minIntensity, this.randomMode.maxIntensity];
				this.command = str.map(byte => byte.toString(16).toUpperCase().padStart(2, '0')).join('');
				this.pushMsgToApp("mqtt_h5_100002") //推送
				console.log('发送随机模式指令:', this.command);
			},

			//----------------------------------------------------------------------------------------------------------------------------------------------
			//摇一摇模式
			toggleShakeMode() { //开启或者关闭 切换摇一摇模式
				this.shakeMode.enabled = !this.shakeMode.enabled;
				if (!this.shakeMode.enabled) {
					const str = ["AA", "04", "00", "00", "01"];
					this.command = str.map(byte => byte.toString(16).toUpperCase().padStart(2, '0')).join('');
					this.pushMsgToApp("mqtt_h5_100002") //推送
					console.log('发送摇一摇模式指令:', this.command);
				}
			},

			sendShakeModeCommand() { // 发送摇一摇模式指令
				const str = ["AA", "04", this.shakeMode.rotationIntensity, this.shakeMode.shockIntensity, this.shakeMode
					.rotationDirection
				];
				this.command = str.map(byte => byte.toString(16).toUpperCase().padStart(2, '0')).join('');
				this.pushMsgToApp("mqtt_h5_100002") //推送
				console.log('发送摇一摇模式指令:', this.command);
			},
			//----------------------------------------------------------------------------------------------------------------------------------------------
			//推送
			pushMsgToApp(mqttType) { //推送给APP
				//this.isDataLoading = true;
				axios.post(this.$p_url + '/feign/airplane_cup/h5/pushMsgToApp', {
						toyUid: this.toyId,
						receiverID: this.receiverID,
						command: this.command,
						mqttType: mqttType
					}, {
						withCredentials: true,
						headers: {
							'Content-Type': 'application/json',
							'Accept': '*/*',
							'token': Cookies.get("token"),
							'webId': this.uuid,
						},
					})
					.then(response => {
						this.isDataLoading = false;
						console.log("推送给APP：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态

						}
					})
					.catch(error => { // 请求失败时处理错误
						this.open4(this.$t('language000430'))
						this.isDataLoading = false;
						console.error('Error fetching data:', error);
					});
			},
			open2(string) {
				this.$message({
					message: string,
					type: 'success'
				});
			},
			open4(string) {
				this.$message.error(string);
			},
			//...
		},
	};
</script>

<style scoped>


</style>